import { SubscriptionType } from '@sweetspot/shared/types'
import { useTranslation } from 'react-i18next'

interface PlayerImportSheetProps {
  subscriptionType: SubscriptionType
}

export const Instructions = ({ subscriptionType }: PlayerImportSheetProps) => {
  const { t } = useTranslation()

  return (
    <div className="space-y-4 p-6 text-sm">
      <div>
        <h2 className="font-bold">
          {t('memberships.membershipImports.instructions.heading_instructions')}
        </h2>
        <p>{t('memberships.membershipImports.instructions.players.warning')}</p>
      </div>

      <div>
        <h2 className="font-bold">{t('words.email')}</h2>
        <p>{t('memberships.membershipImports.instructions.email')}</p>
      </div>
      <div>
        <h2 className="font-bold">
          {subscriptionType === SubscriptionType.MEMBERSHIP
            ? t('sentences.membership_uuid')
            : t('sentences.pass_uuid')}
        </h2>
        <p>
          {subscriptionType === SubscriptionType.MEMBERSHIP
            ? t('memberships.membershipImports.instructions.players.membership_uuid')
            : t('memberships.membershipImports.instructions.players.pass_uuid')}
        </p>
      </div>
      <div>
        <h2 className="font-bold">{t('words.expirationDate')}</h2>
        <p>
          {subscriptionType === SubscriptionType.MEMBERSHIP
            ? t('memberships.membershipImports.instructions.expiration_date')
            : t('memberships.membershipImports.instructions.expiration_date_pass')}
        </p>
        <p className="pt-1 font-bold">
          {t('memberships.membershipImports.instructions.label_instructions')}
        </p>
      </div>
    </div>
  )
}
